import "../sidebar/sidebar.css";
import ic_new_chat from "../assets/new_chat.svg"
import ic_close from "../assets/ic_close.svg";

function Sidebar({ onClose, onNewChat, chatHistory, onSelectChat }) {
  // Function to group chats by date
  const groupChatsByDate = () => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    // Format dates for comparison
    const todayStr = today.toDateString();
    const yesterdayStr = yesterday.toDateString();

    // Group chats
    const groups = chatHistory.reduce((acc, chat) => {
      const chatDate = new Date(chat.timestamp).toDateString();

      if (chatDate === todayStr) {
        acc.today.push(chat);
      } else if (chatDate === yesterdayStr) {
        acc.yesterday.push(chat);
      } else if (new Date(chat.timestamp) > yesterday) {
        acc.older.push(chat);
      }

      return acc;
    }, { today: [], yesterday: [], older: [] });

    // Create thread data structure
    const threadData = [];

    if (groups.today.length > 0) {
      threadData.push({
        title: "Today",
        items: groups.today.map(chat => chat.title)
      });
    }

    if (groups.yesterday.length > 0) {
      threadData.push({
        title: "Yesterday",
        items: groups.yesterday.map(chat => chat.title)
      });
    }

    if (groups.older.length > 0) {
      threadData.push({
        title: "Older",
        items: groups.older.map(chat => chat.title)
      });
    }

    return threadData;
  };

  const threadData = groupChatsByDate();

  return (
    <div className="sidebar">
      <div className="sidebar-top">
        <button className="newBtn" onClick={onNewChat}>
          <img src={ic_new_chat} alt="" />
          <p>New Chat</p>
        </button>
        <button className="close-btn" onClick={onClose}>
          <img src={ic_close} alt="" />
        </button>
      </div>
      <div className="threadbody">
        {threadData.map((section, index) => (
          <div key={index}>
            <h3>{section.title}</h3>
            <ul>
              {section.items.map((item, idx) => {
                // Find the chat object that matches this title
                const chat = chatHistory.find(c => c.title === item);
                return (
                  <li key={idx}>
                    <a
                      href="/#"
                      title={item}
                      onClick={(e) => {
                        e.preventDefault();
                        if (chat) {
                          onSelectChat(chat.id);
                        }
                      }}
                    >
                      {item}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
        {threadData.length === 0 && (
          <div className="no-chats">
            <p>No history yet</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Sidebar;
